<template>
  <section class="section--stories">
    <v-container>
      <v-row justify="center" class="section__row">
        <v-col
          class="section__col"
          :cols="12"
          :sm="8"
          :lg="6"
          :xs="12"
          v-for="story in stories"
          :key="story.id"
        >
          <story-card
            :image="story.image"
            :tags="story.tags"
            :title="story.title"
            :description="story.description"
            :logo="story.logo"
            :route="story.route"
            :show-card="true"
            :max-width="520"
            :maxImageHeight="240"
          />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import StoryCard from './StoryCard.vue';

export default {
  name: 'StoriesSection',
  components: {
    'story-card': StoryCard,
  },
  data: () => ({
    stories: [
      {
        id: '1',
        image: require(`@/assets/img/divacs-cover.svg`),
        tags: 'B2B SAAS',
        title: 'Scaling DIVACS With DIGU',
        description:
          'With DIGU, DIVACS cut costs by 70% and onboarded top talent in less than 40 days.',
        logo: require(`@/assets/img/divac-logo.svg`),
        route: '/divacs', // Unique route for this story
      },
      {
        id: '2',
        image: require(`@/assets/img/anthropic-cover.svg`),
        tags: 'B2B Services',
        title: 'Anthropic Identity Builds a Global IAM Force',
        description:
          'Anthropic Identity cut hiring time by 75% and built a global IAM team in just 2 weeks',
        logo: require(`@/assets/img/anthropic-logo.svg`),
        route: '/anthropic-identity', // Unique route for this story
      },
      {
        id: '3',
        image: require(`@/assets/img/sharpscribe.svg`),
        tags: 'B2B SAAS',
        title: 'SharpScribe Brings AI to the Doctor’s Office',
        description: 'SharpScribe built its AI MVP 40% faster',
        logo: require(`@/assets/img/sharpscribe-logo.svg`),
        route: '/sharp-scribe', // Unique route for this story
      },
    ],
  }),
};
</script>

<style scoped>
.section--stories {
  padding: 4rem 0 0 0;
}

.section__row {
  max-width: 1300px;
  margin-inline: auto;
}

@media only screen and (max-width: 960px) {
  .section--stories {
    /* background-color: #cfecfc; */
    margin: 0;
    padding: 0;
    padding-top: 3rem;
  }
}
</style>
